// Design System 2.0 (2026-10, Phase 1) — one Tabs primitive covering the three modes the app
// currently hand-rolls separately: "page" (Clients.jsx SEGMENTS pills), "record" (Project
// Detail's ProjectPageTabs underline tabs), "sub" (Tasks.jsx scope/status pill toggles).
// New, unused by any page yet — ProjectPageTabs/SEGMENTS/Tasks pill toggles keep working
// unchanged; their own pages migrate to this in later phases.
const VARIANTS = {
  page: {
    list: "inline-flex items-center gap-1 rounded-md border border-hairline bg-paper p-1",
    tab: (active) => `rounded px-3 py-1.5 text-xs font-medium transition-colors ${active ? "bg-brand text-ink" : "text-ink-soft hover:text-ink"}`,
  },
  record: {
    list: "flex items-center gap-1 border-b border-hairline overflow-x-auto",
    tab: (active) => `px-3 py-2.5 text-sm whitespace-nowrap border-b-2 transition-colors ${active ? "border-brand text-ink font-semibold" : "border-transparent text-faint hover:text-ink"}`,
  },
  sub: {
    list: "inline-flex rounded-md border border-hairline p-0.5 bg-surface2",
    tab: (active) => `rounded-[3px] px-2.5 py-1 text-xs font-medium transition-colors ${active ? "bg-paper text-ink shadow-sm" : "text-faint hover:text-ink"}`,
  },
};

export function Tabs({ variant = "page", tabs, value, onChange, testId, className = "" }) {
  const v = VARIANTS[variant] || VARIANTS.page;
  return (
    <div className={`${v.list} ${className}`} data-testid={testId} role="tablist">
      {tabs.map((t) => (
        <button
          key={t.key}
          type="button"
          role="tab"
          aria-selected={t.key === value}
          onClick={() => onChange(t.key)}
          data-testid={testId ? `${testId}-${t.key}` : undefined}
          className={v.tab(t.key === value)}
        >
          {t.label}
          {t.count !== undefined && <span data-testid={t.countTestId} className="ml-1.5 text-[11px] opacity-70 font-mono">{t.count}</span>}
        </button>
      ))}
    </div>
  );
}
